// @flow
import React, { Component } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";

type MuiDialogHeaderPropsType = {
  onClose: Function,
  title: string
};

const MuiDialogHeader = (props: MuiDialogHeaderPropsType): React$Element<*> => (
  <AppBar position="absolute" color="primary">
    <Toolbar>
      <Typography variant="h6" color="inherit" style={{ flex: 1 }}>
        {props.title}
      </Typography>
      <IconButton color="inherit" onClick={props.onClose} aria-label="Close">
        <CloseIcon />
      </IconButton>
    </Toolbar>
  </AppBar>
);

export default MuiDialogHeader;
